export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10918.37fd88e6.jpg";